module.exports = require("dgram");